import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("yl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  if (localStorage.getItem("yl_demo_mode") === "1") config.headers["X-Demo-Mode"] = "1";
  return config;
});

export const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

// Poll a background job until it is done or errors.
export async function pollJob(jobId, { interval = 2500, timeout = 600000, onTick } = {}) {
  const start = Date.now();
  while (Date.now() - start < timeout) {
    await sleep(interval);
    const { data } = await api.get(`/jobs/${jobId}`);
    if (onTick && data.step) onTick(data.step);
    if (data.status === "done") return data.result;
    if (data.status === "error") throw new Error(data.error || "Job failed");
  }
  throw new Error("This is taking longer than expected. Please try again.");
}

export default api;
